module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-minus-d8d519b9.svg";